import React from "react";

const FilterSelectInputSearch = (props) => {
  return (
    <span className="search-filter">
      <input
        className="search-filter-input"
        value={props.valueInputSearch}
        onChange={props.onChangeInputSearch}
        placeholder="Search for"
        autoFocus={props.valueInputSearch && props.valueInputSearch.length > 0}
      />
      {!props.isOpen.option ? (
        <span
          className="search-filter-clean"
          onClick={() => props.setValueInputSearch("")}
        >
          x
        </span>
      ) : (
        ""
      )}
    </span>
  );
};

export default FilterSelectInputSearch;
